module.exports = __webpack_public_path__ + "static/media/_ossetia.f8e9ff2d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_ossetia.svg
// module id = 2343
// module chunks = 7